import React from 'react';
import {
  Text,
  Container,
  Box,
  Divider,
  Group, 
} from '@mantine/core';
import { useId } from '@mantine/hooks';
import Link from './Link';

function HomePageFooter() {

  const footerTextStyles = {
    fz: 'xs',
    c: 'gray.6',
  };

  const footerLinks = [
    {
      key: useId(),
      text: 'Contact',
      href: '?contact=true',
    },
    {
      key: useId(),
      text: 'Terms',
      href: '/terms',
    },
    {
      key: useId(),
      text: 'Privacy',
      href: '/privacy',
    }
  ];

  return (
    <Box>
      <Container px='xl'>
        <Divider color='gray.2' />
        <Group style={{ justifyContent: 'space-between'}} noWrap pt='xl' pb={40}>
          <Text {...footerTextStyles}>
            &copy;2025 Osprey Design 
          </Text>
          <Group spacing={4}>
            { footerLinks.map(({ key, text, href }, idx) => (
              <React.Fragment key={key}>
                <Link 
                  href={href}
                  anchorProps={{
                    underline: true,
                    fw: 400,
                    ...footerTextStyles,
                  }}
                >
                {text}
                </Link>  
                { (idx + 1 !== footerLinks.length) && <Text mx={2} {...footerTextStyles}>&middot;</Text> } 
              </React.Fragment>
            )) }
          </Group>
        </Group>
      </Container>
    </Box>
  )
};

export default HomePageFooter;